import { Injectable } from "@angular/core";
import { AngularFireDatabase } from "angularfire2/database";
import { Utilities } from "./utilities";

@Injectable()
export class FavoriteService {

  public action = "edit";

  constructor(
    private afdb: AngularFireDatabase,
    private utilities: Utilities,
  ) { }

  public getList(clientId: string, eventId: string = null) {
    let ref = `Clients/${clientId}/Interactivity/FavoritesConfig`;
    if (this.utilities.validateEventIdParam(eventId)) {
      ref = `Clients/${clientId}/Event/${eventId}/FavoritesConfig`;
    }
    return this.afdb.list<any>(ref).valueChanges();
  }

  public getItem(clientId: string, favoriteId: string, eventId: string = null) {
    let ref = `Clients/${clientId}/Interactivity/FavoritesConfig/${favoriteId}`;
    if (this.utilities.validateEventIdParam(eventId)) {
      ref = `Clients/${clientId}/Event/${eventId}/FavoritesConfig/${favoriteId}`;
    }
    return this.afdb.object<any>(ref).valueChanges();
  }

  public createOrEdit(clientId: string, info: any) {
    if (!info.id) {
      info.id = this.utilities.generateRamdomKey();
      this.action = "create";
    }

    let ref = `Clients/${clientId}/Interactivity/FavoritesConfig/${info.id}`;
    if (this.utilities.validateEventIdParam(info.eventId)) {
      ref = `Clients/${clientId}/Event/${info.eventId}/FavoritesConfig/${info.id}`;
    }

    return new Promise((res, rej) => {
      this.afdb.database
        .ref(ref)
        .set(info)
        .then(() => {
          return res(info.id);
        })
        .catch((e) => {
          return rej(e);
        });
    });
  }
}



// WEBPACK FOOTER //
// ./src/providers/favorite.service.ts